/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review1_QuoteInputs */

const es_landing_review1_quote = /** @type {(inputs: Landing_Review1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia 100% recomendable si te gusta navegar y no tienes barco. Muy buen plan con amigos; el permiso de Cíes lo llevan ellos. Deseando repetir.`)
};

const gl_landing_review1_quote = /** @type {(inputs: Landing_Review1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia 100% recomendable se che gusta navegar e non tes barco. Moi bo plan con amigos; o permiso das Cíes lévano eles. Con ganas de repetir.`)
};

const en_landing_review1_quote = /** @type {(inputs: Landing_Review1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% recommendable if you love sailing and do not own a boat. Great plan with friends; they handle the Cíes permit. Cannot wait to do it again.`)
};

/**
* | output |
* | --- |
* | "100% recommendable if you love sailing and do not own a boat. Great plan with friends; they handle the Cíes permit. Cannot wait to do it again." |
*
* @param {Landing_Review1_QuoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review1_quote = /** @type {((inputs?: Landing_Review1_QuoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review1_QuoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review1_quote(inputs)
	if (locale === "en") return en_landing_review1_quote(inputs)
	return es_landing_review1_quote(inputs)
});